import classNames from "classnames";
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import { useTranslate } from "../../../language/i18n";
import Label from "../Label/Label";
import styles from "./ClampedNote.module.scss";

const ClampedNote = ({ label, value, customCssClass }) => {
  const [expanded, setExpanded] = useState(false);
  const [overflows, setOverflows] = useState(false);
  const translate = useTranslate();
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;
    const id = requestAnimationFrame(() => {
      if (ref.current) {
        setOverflows(ref.current.scrollHeight > ref.current.clientHeight);
      }
    });
    return () => cancelAnimationFrame(id);
  }, [value]);

  return (
    <div className={classNames(styles.clampedNote, customCssClass)}>
      <div ref={ref} className={classNames(!expanded && styles.clamped)}>
        <Label label={label} value={value} inline />
      </div>
      {(overflows || expanded) && (
        <button className={styles.expandToggle} onClick={() => setExpanded(prev => !prev)}>
          {translate(expanded ? "SHOW_LESS" : "SHOW_MORE")}
        </button>
      )}
    </div>
  );
};

ClampedNote.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  customCssClass: PropTypes.string,
};

export default ClampedNote;
